import React from "react"

import {
  TypographyH2,
  TypographyH3,
  TypographyInlineCode,
  TypographyList,
  TypographyP
} from "@javascript/components/ui/typography"

interface Block {
  type: string
  renderer: string
  configOptions: Record<string, unknown>
}

interface BlockReferencePageProps {
  blocks: Block[]
}

export function BlockReferencePage({ blocks }: BlockReferencePageProps) {
  return (
    <div className="space-y-8">
      <div>
        <TypographyH2>Block Reference Catalog</TypographyH2>
        <TypographyP>
          Blocks are platform-defined presentation capabilities. Every renderer receives the same immutable canonical invitation context, scoped asset resolver, RSVP URL, and clock; a block never owns storage or host-form fields.
        </TypographyP>
      </div>

      <div>
        <TypographyH3>Available block types</TypographyH3>
        <TypographyList>
          {blocks.map((block) => <li key={block.type}><TypographyInlineCode>{block.type}</TypographyInlineCode></li>)}
        </TypographyList>
      </div>

      {blocks.map((block) => {
        const optionNames = Object.keys(block.configOptions)

        return (
          <div key={block.type}>
            <TypographyH3>{block.type} block</TypographyH3>
            <TypographyP>Renderer: <TypographyInlineCode>{block.renderer}</TypographyInlineCode></TypographyP>
            {optionNames.length > 0 ? (
              <>
                <TypographyP>Theme-level presentation options:</TypographyP>
                <TypographyList>{optionNames.map((name) => <li key={name}><TypographyInlineCode>{name}</TypographyInlineCode></li>)}</TypographyList>
              </>
            ) : (
              <TypographyP>This block has no theme-configurable options.</TypographyP>
            )}
          </div>
        )
      })}

      <div>
        <TypographyH3>Using blocks in your theme</TypographyH3>
        <TypographyP>
          Declare an instance in <TypographyInlineCode>theme.json</TypographyInlineCode>, then place that instance ID with <TypographyInlineCode>{`{% block "id" %}`}</TypographyInlineCode>. Themes can use these capabilities but never define new behavior.
        </TypographyP>
      </div>
    </div>
  )
}
